import { useEffect, useState } from "react";

import { useLocation } from "react-router-dom";
import { connect } from "react-redux";

import FileSaver from "file-saver";
import toast, { Toaster } from "react-hot-toast";
import {
  CommonHeader,
  ErrorSuccessModal,
  Loader,
} from "../../../../components/commons";
import {
  BulkUploadError,
  BulkUploadSuccess,
  DownloadIcon,
  ReloadIcon,
} from "../../../../components/Icon";
import DraggableUpload from "../../../../components/commons/Upload/DraggableUpload";
import { RootState } from "../../../../redux/rootReducers";
import {
  getRecruitmentTrackerBulkUploadHistoryAction,
  recruitementTrackerBulkUploadAction,
  resetBulkUploadHistoryCount,
  resetBulkUploadHistoryData,
  resetHrmsBulkUpload,
  resetHrmsError,
  resetHrmsMessage,
  resetHrmsSuccess,
} from "../../../../redux/hrms";
import { resetSession } from "../../../../redux/auth";
import { GetHrmsBulkUploadHistoryPayloadType, RecruitmentTrackerBulkUploadType } from "../../../../commonTypes/hrmsTypes";
import BulkUploadHistoryModal from "../../../../components/InvoiceGeneration/BulkUploadHistory/BulkUploadHistoryModal";
import { HrmsBulkUploadHistoryDataType } from "../../../../redux/hrms/hrmsTypes";
import { useMenuCheck } from "../../../../customHooks/useMenuCheck";

const blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
const blobToken = process.env.REACT_APP_BLOB_TOEKN;

interface Props {
  history: any;
  token: string | null;
  bulkUploadData: any | null;
  fetching: boolean;
  success: number | null;
  error: string | null;
  statusCode: number | null;
  dispatchResetSession: () => void;
  dispatchResetBulkUploadData: Function;
  message: null | string;
  bulkUploadHistoryCount: number;
  dispatchRecruitmentTrackerBulkUpload: (data: RecruitmentTrackerBulkUploadType) => void;
  dispatchResetHrmsSuccess: () => void;
  dispatchResetHrmsError: () => void;
  dispatchResetHrmsMessage: () => void;
  dispatchGetBulkUploadHistoryData:(data: GetHrmsBulkUploadHistoryPayloadType)=>void; 
  bulkUploadHistoryData: HrmsBulkUploadHistoryDataType[] | [];
  dispatchResetBulkUploadHistoryData:()=>void;
  dispatchResetBulkUploadHistoryCount:()=>void;
}

const OTHER_COLUMN_NAMES: any[] = [
  "Application ID",
  "Date",
  "Applicant Name",
  "Apply For (Job Position)",
  "Mobile Number",
  "Email Id",
  "Resume Link",
  "Job Id",
];

const RecruitmentTrackerBulkUpload = ({
  history,
  token,
  bulkUploadData,
  success,
  error,
  statusCode,
  fetching,
  dispatchResetSession,
  dispatchResetBulkUploadData,
  message,
  bulkUploadHistoryCount,
  dispatchRecruitmentTrackerBulkUpload,
  dispatchResetHrmsSuccess,
  dispatchResetHrmsError,
  dispatchResetHrmsMessage,
  dispatchGetBulkUploadHistoryData,
  bulkUploadHistoryData,
  dispatchResetBulkUploadHistoryData,
  dispatchResetBulkUploadHistoryCount

}: Props) => {
  const [fileData, setFileData] = useState<any>("");
  const [fileNames, setFileNames] = useState([]);
  const [isBulkHistory,setIsBulkHistory]=useState(false);
  const [offset,setOffset]=useState(0);
  const [limit,setLimit]=useState(20);
  const [showToast, setShowToast] = useState(true); 
  const [historyData,setHistoryData]=useState<HrmsBulkUploadHistoryDataType[] | []>([]);
  const findingRoute = useLocation().pathname.split("/");
  const routeName = findingRoute[2];
  // USER MANAGEMENT

  const [isBulkUploadHistoryPresent, setIsBulkUploadHistoryPresent] = useMenuCheck();

  useEffect(() => {
    dispatchResetBulkUploadData();
    dispatchResetHrmsSuccess();
    dispatchResetHrmsError();
    dispatchResetHrmsMessage();
    dispatchResetBulkUploadHistoryCount();
    dispatchResetBulkUploadHistoryData();
    setIsBulkUploadHistoryPresent("Bulk Upload History Recruitment Tracker", "menu");
  }, []);

  useEffect(()=>{
    if(token && offset>0 && offset<+bulkUploadHistoryCount){
      let finalData={
        token,
        limit,
        offset
      }
      dispatchGetBulkUploadHistoryData(finalData)
    }
  },[offset])

  useEffect(() => {
    if (bulkUploadHistoryData?.length === 0) {
      setHistoryData(bulkUploadHistoryData);
    }
    if (offset > 0) {
      setHistoryData((prv: any) => [...prv, ...bulkUploadHistoryData]);
    } else {
      setHistoryData(bulkUploadHistoryData);
    }
  }, [bulkUploadHistoryData]);

  const handleViewHistory=()=>{
    dispatchResetBulkUploadData();
    toast.dismiss()
    if(token){
      let finalData={
        token,
        limit,
        offset
      }
      dispatchGetBulkUploadHistoryData(finalData)
    }
    setIsBulkHistory((prev:boolean)=>!prev)
  }

  const downloadTemplate = () => {
    setShowToast(false);
    let headList: string[] = [];

    OTHER_COLUMN_NAMES.map((item: any) => {
      headList.push(item);
    });
    let csvData = headList.toString();
    var blob = new Blob([csvData], {
      type: "text/csv;charset=utf-8;",
    });

    FileSaver.saveAs(blob, "template.csv");
  };
  const handleUpload = (file: any) => {
    setFileData(file);
  };
  const startBulkProcess = () => {
    const params = {
      fileData,
      token,
    };
    dispatchRecruitmentTrackerBulkUpload(params);
  };

  const toogleBulkHistoryModal=()=>{
    setOffset(0)
    setHistoryData([])
    dispatchResetBulkUploadHistoryCount()
    dispatchResetBulkUploadHistoryData()
    setIsBulkHistory((prev:boolean)=>!prev)
  }

  const handleErrorModal = () => {
    if ((bulkUploadData && bulkUploadData?.success === 0) || success === 0) {
      if (
        (bulkUploadData && bulkUploadData?.status_code === 401) ||
        statusCode === 401
      ) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="Logout"
            onPress={() => {
              dispatchResetSession();
              dispatchResetHrmsError();
            }}
            statusCode={statusCode}
          />
        );
      } else if (
        (bulkUploadData && bulkUploadData?.status_code === 204) ||
        (bulkUploadData && bulkUploadData?.status_code === 500) ||
        error
      ) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!bulkUploadData?.success}
            title="Error"
            message={
              routeName === "bulk-upload" && bulkUploadData.status_code === 500
                ? "Columns are missing"
                : bulkUploadData?.message || error || "something went wrong!"
            }
            buttonText="OK"
            onPress={() => {
              dispatchResetBulkUploadData();
              setFileNames([]);
              dispatchResetHrmsSuccess();
              dispatchResetHrmsError();
              dispatchResetHrmsMessage();
            }}
          />
        );
      }
    }

    if (
      bulkUploadData?.success === 1 &&
      bulkUploadData &&
      bulkUploadData?.message
    ) {
      if (bulkUploadData && bulkUploadData?.error_docs_count === 0) {
        return (
          <ErrorSuccessModal
            type="success"
            isOpen={bulkUploadData?.success === 1}
            title="Success"
            message={
              bulkUploadData?.message || "Document Uploaded Successfully!"
            }
            buttonText="OK"
            onPress={() => {
              dispatchResetBulkUploadData();
              setFileNames([]);
              history.goBack();
              dispatchResetHrmsSuccess();
              dispatchResetHrmsError();
              dispatchResetHrmsMessage();
            }}
            statusCode={bulkUploadData?.status_code || statusCode}
          />
        );
      } else if (showToast) {
        if (bulkUploadData?.total_inserted_docs === 0) {
            toast.error("Bulk upload unsuccessful!");
        } else {
          toast.success(bulkUploadData?.message);
        }
        setShowToast(false);
      }
    }
    return false;
  };
  const renderReUpload = () => {
    const {
      total_rows_count,
      total_inserted_docs,
      error_docs_count,
      error_file,
    } = bulkUploadData;
    return (
      <div className="dropzone drop-area" style={{ cursor: "default" }}>
        <h3>
          File Uploaded Successfully{" "}
          {error_docs_count === 0 ? "" : "But Found Errors"}
        </h3>
        <hr />

        <div className="details-card">
          <div>
            <h5>Overview</h5>
            <div className="overview-card">
              <div className="card inside-card">
                <BulkUploadSuccess />
                <h6>
                  <span className="counter-style">{total_inserted_docs}</span>{" "}
                  out of {total_rows_count}{" "}
                </h6>
                <h6 className="counter-sub-header mt-2">Successfull entries</h6>
              </div>
              <div className="card inside-card">
                <BulkUploadError />
                <h6>
                  <span className="counter-style">{error_docs_count}</span> out
                  of {total_rows_count}
                </h6>
                <h6 className="counter-sub-header mt-2">Total errors</h6>
              </div>
            </div>
          </div>

          <div>
            <h5>Please follow the steps below to fix it.</h5>
            <div>
              <div className="card card-text">
                {" "}
                <h5>
                  <span className="card-span">01</span>Please download the file.
                </h5>{" "}
              </div>
              <div className="card card-text">
                <h5>
                  <span className="card-span">02</span>Fix the errors
                </h5>{" "}
              </div>
              <div className="card card-text">
                <h5>
                  <span className="card-span">03</span>Re-upload the file.
                </h5>{" "}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-5 mb-5 d-flex justify-content-end">
          <button
            className="ml-3 btn btn-primary"
            onClick={() => {
              handleReUpload()
              setShowToast(true);
            }}
          >
            Proceed to Re-Upload
          </button>
          <div className="ml-4">
            <a
              href={blobBaseUrl + error_file + "?" + blobToken}
              className="btn btn-outline-info "
            >
              Download Error CSV
            </a>
          </div>
        </div>
      </div>
    );
  };

  const handleReUpload = () => {
    dispatchResetBulkUploadData();
    setFileNames([]);
    setFileData("");
  };

  return (
    <div className="row">
      <div className="col-md-8 mb-3">
        <CommonHeader goBack title={`Bulk Upload - Recruitment Tracker`} />
      </div>
      <div className="col-12">
        <div className=" card p-3">
          <div className="d-flex justify-content-end" style={{ gap: "10px" }}>
            <p className="text-right">
              <button className="btn btn-outline" onClick={() => {
                setShowToast(false);
                downloadTemplate()
              }}
              >
                <DownloadIcon color="#DD4433" /> Download Blank Template
              </button>
            </p>
          
            {isBulkUploadHistoryPresent ? 
            <p className="text-right">
            <button
              className="btn btn-outline"
              onClick={() => handleViewHistory()}
            >
              <ReloadIcon color="#DD4433"/>
                View History
            </button>
            </p> : null}
            </div>

          {bulkUploadData && bulkUploadData.error_file ? (
            renderReUpload()
          ) : (
            <DraggableUpload
              handleUpload={handleUpload}
              setFileNames={setFileNames}
              fileNames={fileNames}
              acceptedFileTypes=".csv,text/csv,application/csv"
            />
          )}
          {bulkUploadData && bulkUploadData.error_file ? null : (
            <div className="mt-3 d-flex">
              <button
                className="btn btn-primary btn-lg w-50 m-auto"
                onClick={() => {
                  startBulkProcess();
                  setShowToast(true);
                }}
                disabled={
                  !fileData || !fileNames.length || fetching ? true : false
                }
              >
                Proceed
              </button>
            </div>
          )}
        </div>

        {
          isBulkHistory ?
          <div>
            <BulkUploadHistoryModal
             isBulkHistory={isBulkHistory}
             toogleBulkHistoryModal={toogleBulkHistoryModal}
             historyData={historyData}
             fetching={fetching}
             offset={offset}
             setOffset={setOffset}
             limit={limit}
            />
          </div> : null
         }

        {fetching ? <Loader /> : null}
        {handleErrorModal()}
        <Toaster />
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  bulkUploadData: state.hrms.hrmsBulkUploadData,
  token: state.auth.token,
  fetching: state.hrms.fetching,
  success: state.hrms.success,
  message: state.hrms.message,
  error: state.hrms.error,
  statusCode: state.hrms.statusCode,
  bulkUploadHistoryData: state.hrms.bulkUploadHistoryData,
  bulkUploadHistoryCount: state.hrms.bulkUploadHistoryCount,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchRecruitmentTrackerBulkUpload: (data: RecruitmentTrackerBulkUploadType) =>
    dispatch(recruitementTrackerBulkUploadAction(data)),
  dispatchResetBulkUploadData: () => dispatch(resetHrmsBulkUpload()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetHrmsSuccess: () => dispatch(resetHrmsSuccess()),
  dispatchResetHrmsError: () => dispatch(resetHrmsError()),
  dispatchResetHrmsMessage: () => dispatch(resetHrmsMessage()),
  dispatchGetBulkUploadHistoryData: (data: GetHrmsBulkUploadHistoryPayloadType) => dispatch(getRecruitmentTrackerBulkUploadHistoryAction(data)),
  dispatchResetBulkUploadHistoryCount: () => dispatch(resetBulkUploadHistoryCount()),
  dispatchResetBulkUploadHistoryData: () => dispatch(resetBulkUploadHistoryData()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RecruitmentTrackerBulkUpload);
